<template>
  <div class="management-page-outer-container">
    <div
      class="data-bigger-side-container scroll-fire-fox"
      style="padding: 90px 40px"
    >
      <div class="management-section-wrapper">
        <v-card-title>
          <span class="management-section-title">
            {{ $tc("AssetReservation", 2) }}
          </span>

          <v-spacer />

          <v-flex xs2 class="mr-3">
            <v-autocomplete
              :label="$tc('Workspace', 1)"
              :value="workspaceUuid"
              @change="$emit('update-workspace-uuid', $event)"
              :items="workspaceOptions"
              :loading="workspaceOptionsAreLoading"
              item-text="wp_label"
              item-value="wp_uuid"
              clearable
            />
          </v-flex>

          <v-flex xs2 class="mr-3">
            <v-text-field
              :label="$t('Search')"
              :placeholder="$t('Search')"
              :value="search"
              @input="$emit('update-search', $event)"
              append-icon="search"
              single-line
            />
          </v-flex>
        </v-card-title>

        <reservations-table
          :reservations="reservations"
          :loading="loading"
          :workspace-uuid="workspaceUuid"
          :is-normal-user="isNormalUser"
          :search-from-parent="search"
          @open-reservation="openReservation"
        />
      </div>
    </div>

    <div class="data-smaller-side-container">
      <side-map :workspace-uuid="workspaceUuid" :reservations="reservations" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SideMap from "@/components/Management/ManagementSideMapWorkspace";
import ReservationsTable from "@/components/AssetReservationManagement/Data/ReservationsTable";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "AssetReservationManagementReservationsList",

  components: { SideMap, ReservationsTable },

  mixins: [checkPermissionsMixin],

  props: {
    /**
     * Receives the uuid the selected workspace
     */
    workspaceUuid: {
      type: String
    },

    /**
     * Receives the value of the last search
     */
    search: {
      type: String
    }
  },

  data() {
    return {
      /**
       * List of available workspace options
       */
      workspaceOptions: [],
      /**
       * Determines if the request to fetch the list of
       * available workspace options has not yet ended
       */
      workspaceOptionsAreLoading: false,

      /**
       * List of reservations
       */
      reservations: [],
      /**
       * Defines the loading of the client roles table
       */
      loading: false
    };
  },

  computed: {
    /**
     * Determines if the user is not admin and not super-admin
     * @returns {boolean}
     */
    isNormalUser() {
      return !this.isSuperAdmin && !this.isAdmin;
    }
  },

  watch: {
    /**
     * Whenever the workspaceUuid changes, the loadReservations method is called.
     */
    workspaceUuid() {
      this.loadReservations();
    }
  },

  created() {
    this.loadWorkspaceOptions();
    this.loadReservations();
  },

  methods: {
    ...mapActions([
      "fetchObjectByUUID",
      "fetchUserAndCompanyWorkspaces",
      "setAssetReservationManagementWorkspace",
      "fetchAssetReservations"
    ]),

    /**
     * Get the list of reservations
     * @returns {Promise<void>}
     */
    async loadReservations() {
      this.reservations = [];
      if (!this.isNormalUser || this.workspaceUuid) {
        this.loading = true;
        try {
          this.reservations = await this.fetchAssetReservations({
            fieldsToAppend: "installation_deadline,state",
            workspaceUUID: this.workspaceUuid
          });
        } catch (e) {
          console.log(e);
        }
        this.loading = false;
      }
    },

    /**
     * Loads the list of workspaces the user has access to.
     */
    loadWorkspaceOptions() {
      this.workspaceOptionsAreLoading = true;
      this.fetchUserAndCompanyWorkspaces()
        .then(workspaces => {
          this.workspaceOptions = workspaces;
        })
        .catch(error => {
          console.error(error);
        })
        .then(() => {
          this.workspaceOptionsAreLoading = false;
        });
    },

    /**
     * Push to the page to see the selected reservation
     * @param {Object} reservationUUID - Selected reservation
     */
    openReservation(reservationUUID) {
      this.setWorkspaceUUIDForDetailsMap();
      /**
       * @property {String} name - Name of the route
       * @property {Object} params - Parameters needed for the route path
       */
      this.$router.push({
        name: "asset-reservation",
        params: { uuid: reservationUUID }
      });
    },

    /**
     * Send the workspace the uuid to the DetailsMap component
     */
    setWorkspaceUUIDForDetailsMap() {
      let workspaceUUID = null;
      if (this.workspaceUuid) {
        workspaceUUID = this.workspaceUuid;
      } else if (this.$store.getters.workspace.uuid) {
        workspaceUUID = this.$store.getters.workspace.uuid;
      } else if (this.workspaceOptions.length > 0) {
        workspaceUUID = this.workspaceOptions[0].wp_uuid;
      }
      this.setAssetReservationManagementWorkspace(workspaceUUID);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AssetReservationManagement/Data/ReservationsList.vue